const memoryStorage = new Map<string, string>()

export function parseStorageJSON<T>(rawValue: unknown, fallback: T): T {
  if (typeof rawValue !== 'string') {
    return fallback
  }

  const value = rawValue.trim()

  if (!value || value === 'undefined') {
    return fallback
  }

  try {
    const parsed = JSON.parse(value) as T | undefined

    return parsed === undefined ? fallback : parsed
  } catch {
    return fallback
  }
}

const serverStorage = new Proxy({} as Storage, {
  get(_, prop: string | symbol) {
    if (prop === 'clear') {
      return () => {
        memoryStorage.clear()
      }
    }

    if (prop === 'getItem') {
      return (key: string) => memoryStorage.get(key) ?? null
    }

    if (prop === 'setItem') {
      return (key: string, value: string) => {
        memoryStorage.set(key, value)
      }
    }

    if (prop === 'removeItem') {
      return (key: string) => {
        memoryStorage.delete(key)
      }
    }

    if (typeof prop === 'string') {
      return memoryStorage.get(prop)
    }

    return undefined
  },
  set(_, prop: string | symbol, value) {
    if (typeof prop === 'string') {
      memoryStorage.set(prop, String(value))
    }

    return true
  },
})

export const browserStorage: Storage =
  typeof window === 'undefined' ? serverStorage : window.localStorage
